import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Valentina R.',
  role: 'mamá de Emilio (8 meses) — Buenos Aires',
  text: 'Llevaba 6 meses sin dormir más de 2 horas seguidas. A la tercera noche con el método, Emilio durmió 5 horas de corrido. Lloré de la emoción. Hoy duerme toda la noche y yo volví a sentirme persona.'
}, {
  name: 'Carolina M.',
  role: 'mamá de Isabella (14 meses) — Bogotá',
  text: 'Probé de todo: el auto, mecerla, YouTube a las 3AM. Nada funcionaba. Con el Método Noches de Paz entendí POR QUÉ se despertaba y en una semana ya dormía sin despertarse. Ojalá lo hubiera encontrado antes.'
}, {
  name: 'Martín y Lucía',
  role: 'papás de Joaquín (6 meses) — Montevideo',
  text: 'Estábamos destruidos como pareja. Las noches eran un campo de batalla. El método nos dio un plan claro que los dos pudimos seguir. Joaquín duerme mejor y nosotros volvimos a ser equipo.'
}, {
  name: 'Fernanda S.',
  role: 'mamá de Sofía (18 meses) — Ciudad de México',
  text: 'Sofía solo se dormía en mis brazos y se despertaba 4 veces por noche. Tenía miedo de que llorar le hiciera daño. El método me dio la tranquilidad de saber que podía ayudarla CON presencia. En 5 días ya se dormía sola en su cuna.'
}, {
  name: 'Diego P.',
  role: 'papá de Mateo (11 meses) — Lima',
  text: 'Mi esposa estaba agotada y yo no sabía cómo ayudar. El método me dio herramientas concretas. Ahora soy yo quien hace el ritual de noche y Mateo se duerme en 15 minutos. Cambió nuestra familia.'
}];
export function TestimonialsSection() {
  return <section className="bg-cream py-20 px-4" data-id="element-298">
      <div className="max-w-6xl mx-auto" data-id="element-299">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-300">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-301">
            Familias que ya recuperaron sus noches
          </h2>
          <p className="text-lg text-navy/70" data-id="element-302">
            Madres y padres reales de bebés de 4 a 24 meses
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-303">
          {TESTIMONIALS.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-soft flex flex-col h-full" data-id="element-304">
              <div className="flex gap-1 text-gold mb-4" data-id="element-305">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-306" />)}
              </div>
              <p className="text-navy/80 italic mb-6 flex-grow" data-id="element-307">
                "{testimonial.text}"
              </p>
              <div data-id="element-308">
                <p className="font-bold text-navy" data-id="element-309">{testimonial.name}</p>
                <p className="text-sm text-navy/60" data-id="element-310">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}